import { useEffect, useState } from "react";
import { get } from "../api/client.ts";
import type { FlatRateSummary } from "../api/types.ts";
import { useBrand } from "./BrandContext.tsx";

/** An unknown plan must never silently fall back to per-card billing. */
export function useFlatRate() {
  const { brand } = useBrand();
  const [plan, setPlan] = useState<FlatRateSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let live = true;
    setLoading(true);
    setFailed(false);
    setPlan(null);
    void get<{ plan: FlatRateSummary | null }>("/api/flat-rate")
      .then(r => { if (live) setPlan(r.plan); })
      .catch(() => { if (live) setFailed(true); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [brand?.id, attempt]);
  return { plan, loading, failed, reload: () => setAttempt(n => n + 1) };
}
